export default class RiskByYearService {
  constructor($http) {
    'ngInject';

    Object.assign(this, {
      $http
    });
  }

  getReport(params) {
    return this.$http.get('/api/report/data_a_y_risk', {
      params: {
        ...params
      }
    }).then(r => r.data);
  }
}



// WEBPACK FOOTER //
// ./components/app/reports/risk-by-year/risk-by-year.service.js